import { useCurrentBoxId } from "@/modules/core/store/useCurrentSpaceManagerStore"
import { RouteNavigate, type RoutePath, useBaseNavigate } from "@modules/navigation/hooks/useBaseNavigate"
import { Path } from "@modules/navigation/routes"
import { type NavigateOptions } from "react-router"

export const useBoxNavigate = () => {
  const boxId = useCurrentBoxId()
  const navigate = useBaseNavigate()

  return (path: RoutePath, options: NavigateOptions & { newBoxId?: string } = {}) => {
    const { newBoxId, ...navigateOption } = options
    navigate(path, () => getBoxPath(path, { newBoxId: newBoxId ?? boxId }), navigateOption)
  }
}

export const getBoxPath = (path: Omit<RoutePath, RouteNavigate.Back>, options?: { newBoxId?: string | null }) => {
  const boxId = options?.newBoxId

  if (boxId) {
    if (path === RouteNavigate.Root) {
      return Path.Box.Root(boxId)
    } else {
      return `${Path.Box.Root(boxId)}/${String(path)}`
    }
  }
  return ""
}
